import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'wordWrap',
    standalone: true
})
export class WordWrapPipe implements PipeTransform {
  transform(value: string, maxLength: number = 50): string[] {
    if (!value) return [];
    const lines: string[] = [];
    // Remove existing line breaks, preserving spaces between words
    const cleanedValue = value.replace(/\r?\n/g, ' ').replace(/\s+/g, ' ');
    // Split by sentence-ending punctuation (., ?, or !), keeping the delimiter
    const sentences = cleanedValue.split(/(?<=[.?!])/).filter(s => s.length > 0);

    let currentLine = '';
    for (let i = 0; i < sentences.length; i++) {
      let sentence = sentences[i];
      const endsWithPunctuation = /[.?!]$/.test(sentence);
      let textToAdd = sentence;

      while (textToAdd.length > 0) {
        // If textToAdd fits in the current line, add it
        if (currentLine.length + textToAdd.length <= maxLength) {
          // Ensure a space between lines if needed
          if (currentLine && !currentLine.endsWith(' ') && !textToAdd.startsWith(' ')) {
            currentLine += ' ';
          }
          currentLine += textToAdd;
          if (endsWithPunctuation && i < sentences.length - 1 && !currentLine.endsWith(' ')) {
            currentLine += ' ';
          }
          textToAdd = '';
        } else {
          // If currentLine has content, push it and reset
          if (currentLine.length > 0) {
            lines.push(currentLine.trimEnd());
            currentLine = '';
          }
          // If textToAdd is too long, find the last space within maxLength
          if (textToAdd.length > maxLength) {
            let spaceIndex = textToAdd.lastIndexOf(' ', maxLength);
            if (spaceIndex <= 0) {
              spaceIndex = textToAdd.indexOf(' ', 1);
              if (spaceIndex === -1 || spaceIndex > maxLength) {
                spaceIndex = maxLength;
              }
            }
            const part = textToAdd.slice(0, spaceIndex);
            currentLine = part.trim();
            if (endsWithPunctuation && part.match(/[.?]$/) && i < sentences.length - 1 && !currentLine.endsWith(' ')) {
              currentLine += ' ';
            }
            textToAdd = textToAdd.slice(spaceIndex).replace(/^\s+/, '');
          } else {
            currentLine = textToAdd.trim();
            if (endsWithPunctuation && i < sentences.length - 1 && !currentLine.endsWith(' ')) {
              currentLine += ' ';
            }
            textToAdd = '';
          }
        }
      }
    }
    if (currentLine.length > 0) {
      lines.push(currentLine.trimEnd());
    }
    return lines;
  }
}